var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppointmentsDeclined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d1315c;}.cls-2{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:90px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "decline"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 300.22,
    cy: 300.44,
    r: 299.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 189.38,
    y1: 404.05,
    x2: 410.02,
    y2: 194.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 410.02,
    y1: 404.05,
    x2: 189.38,
    y2: 194.01
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentsDeclined);
export default __webpack_public_path__ + "static/media/appointments_declined.a78dde4dab4a3191893e566497794ddc.svg";
export { ForwardRef as ReactComponent };